import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim()

export const isCloudSyncConfigured = Boolean(supabaseUrl && supabasePublishableKey)

export const supabase = isCloudSyncConfigured
  ? createClient(supabaseUrl!, supabasePublishableKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null

export const isGoogleAuthProviderEnabled = async (): Promise<boolean> => {
  if (!supabaseUrl || !supabasePublishableKey) return false

  try {
    const response = await fetch(`${supabaseUrl.replace(/\/+$/, '')}/auth/v1/settings`, {
      headers: { apikey: supabasePublishableKey },
    })
    if (!response.ok) return false

    const settings: unknown = await response.json()
    if (!settings || typeof settings !== 'object' || !('external' in settings)) return false
    const external = settings.external
    return Boolean(external && typeof external === 'object' && 'google' in external && external.google === true)
  } catch {
    return false
  }
}
